/* eslint-disable no-magic-numbers */
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  DueListModules,
  ExpirationReasonEnum,
  IDueListItem,
} from 'src/app/due-list/models/due-list-item.model';
import {
  UserDrillsRoutes,
  UserMaintenanceRoutes,
  UserTasksRoutes,
} from '../../../../../core/enums/routes.enum';
import { DueListRoutingLogicService } from '../../../../../due-list/services/due-list-routing-logic.service';

const moduleUrlMapper = {
  core: { route: '' },
  [DueListModules.Certificate]: { route: '' },
  [DueListModules.MaintenanceJob]: { route: UserMaintenanceRoutes.JobPerform },
  [DueListModules.Document]: { route: '' },
  [DueListModules.NonConformance]: { route: '' },
  [DueListModules.NonConformanceSubtask]: { route: '' },
  audit: { route: '' },
  storage: { route: '' },
  [DueListModules.UserCompetence]: { route: '' },
  crewManagement: { route: '' },
  order: { route: '' },
  [DueListModules.Medicine]: { route: '' },
  [DueListModules.Drill]: { route: UserDrillsRoutes.Perform },
  [DueListModules.Work]: { route: UserTasksRoutes.Perform },
  [DueListModules.Runtime]: { route: '' },
  [DueListModules.RiskAssessment]: { route: '' },
  [DueListModules.SignOffPeriod]: { route: '' },
  [DueListModules.AdditionalTime]: { route: '' },
  [DueListModules.WorkSchedule]: { route: '' },
  [DueListModules.CorrectiveAction]: { route: UserMaintenanceRoutes.JobPerform },
};
type ModuleUrlMapper = typeof moduleUrlMapper;

const dueListTypeLabelMapper: Partial<Record<keyof ModuleUrlMapper, string>> = {
  [DueListModules.Work]: 'Task',
  [DueListModules.AdditionalTime]: 'pendingManualTime',
};

@Component({
  selector: 'app-due-list-template',
  templateUrl: './due-list-template.component.html',
  styleUrls: ['./due-list-template.component.scss'],
  standalone: false,
})
export class DueListTemplateComponent implements OnChanges {
  @Input() columnName: string;
  @Input() element: { category: keyof ModuleUrlMapper; [key: string]: any };

  ExpirationReasonEnum = ExpirationReasonEnum;

  constructor(public dueListService: DueListRoutingLogicService) {}

  performRouterLink: string;
  performMaintenanceJobRouterLink: string;
  dueListModules = DueListModules;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.element?.currentValue) {
      const moduleRoute = moduleUrlMapper[this.element.category]?.route ?? '';
      this.performRouterLink = `${moduleRoute}/${this.element.id}`;
      this.performMaintenanceJobRouterLink = moduleRoute
        .replace(':id', this.element.id)
        .replace(':componentId', this.element.componentId);
    }
  }

  saveLastItem(): void {
    this.dueListService.saveLastItem(this.element as IDueListItem);
  }

  performItem(): void {
    this.dueListService.navigateToPerformItem(this.element as IDueListItem);
  }

  performSelectedItem(): void {
    if (
      this.element.category === DueListModules.Work ||
      this.element.category === DueListModules.Drill
    ) {
      this.saveLastItem();
      this.dueListService.navigateToItem(this.performRouterLink, this.element.departmentId);
      return;
    }

    this.performItem();
  }

  getTypeLabelKey(): string {
    return dueListTypeLabelMapper[this.element.category] ?? this.element.category;
  }
}
